import React, { Component } from "react";
import { Container, Button, Icon, Divider, Header, Image } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { COLORS } from '../../utilities/colours'
import axios from 'axios'

class PaymentSuccess extends Component {
    state = { orderDetails: {}, loading: true }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this))
        this.setState({ innerWidth: window.innerWidth })
        const storedOrderDetails = localStorage.getItem('orderDetails')
        if (storedOrderDetails) {
            const parsedDetails = JSON.parse(storedOrderDetails)
            console.log(parsedDetails)
            this.fetchOrderDetails(parsedDetails.orderID)
            this.setState({ orderDetails: parsedDetails, loading: true })
            this.intervalId = setInterval(() => {
                this.myRepeatingFunction(parsedDetails.orderID)
              }, 3000)
              this.timeoutId = setTimeout(() => { 
                clearInterval(this.intervalId) 
                this.setState({ loading: false })
              }, 30000)
        } else {
            this.setState({ loading: false, error: "No order details found" })
        }
    }

    componentWillUnmount() {
        clearInterval(this.intervalId)
        clearTimeout(this.timeoutId)
    }

    myRepeatingFunction = (orderID) => {
        this.fetchOrderDetails(orderID)
    }

    resize() {
        this.setState({ innerWidth: window.innerWidth })
    }
    
    render() {
        const { orderDetails, loading, error, innerWidth } = this.state
        var widthHeight = innerWidth < 800 ? '23%' : '18%'
        var top = innerWidth < 800 ? -40 : 10
        var marginTop = innerWidth < 800 ? 30 : 70
        if (innerWidth < 575) {
            widthHeight = '28%'
            top = -70
        }
        if (innerWidth < 475) {
            widthHeight = '33%'
            top = -120
            marginTop = 0
        }
        if (loading) {
            return (
                <div style={{ background: COLORS.BACKGROUND, minHeight: "100vh", color: COLORS.TEXT_WHITE }}>
                    <Container>
                    <br/><h2 style={{ color: COLORS.TEXT_WHITE, marginTop: 100 }}>Loading order details...</h2>
                    </Container>
                </div>
            )
        }
        if (error) {
            return (
                <div style={{ background: COLORS.BACKGROUND, minHeight: "100vh", color: COLORS.TEXT_WHITE }}>
                    <Container>
                        <br/><h2 style={{ color: COLORS.TEXT_WHITE, marginTop: 100 }}>{error}</h2>
                        <Button style={{ marginTop: 30, marginBottom: 20, backgroundColor: COLORS.PRIMARY_GOLD, color: COLORS.BACKGROUND }} as={Link} to="/consumers">Back to Games</Button>
                    </Container>
                </div>
            )
        }
        return <div style={{ background: COLORS.BACKGROUND, minHeight: "100vh", color: COLORS.TEXT_WHITE }}>
                <Container>
                <Image style={{ position: "absolute", top, left: 20, margin: 0, padding: 0, zIndex: 1000, width: widthHeight, height: widthHeight, objectFit: 'contain' }} src='/egc-logo-transparent.png'/>
                <br/><br/><br/><br/><br/><br/><br/><br/>
                <div style={{ marginTop, padding: 30, border: "1px solid #D1AA64", borderRadius: "6px" }}>
                    {this.renderStatus()}
                    <div style={{ marginTop: 35, padding: 25, border: "1px solid #aaa", borderRadius: "6px" }}>
                    <h3>Helpful Tips</h3>
                    {this.renderTips()}
                    <Button style={{ marginTop: 20, padding: '15px 30px 15px 30px', backgroundColor: '#25D366', color: COLORS.BACKGROUND, marginRight: 15, marginBottom: 10 }} as="a" href="https://wa.me/6592225494" target="_blank"><Icon name="whatsapp" />WhatsApp</Button>
                    <Button style={{ padding: '15px 30px 15px 30px', backgroundColor: '#0088CC', color: COLORS.TEXT_WHITE }} as="a" href="https://t.me/emperor_diamond" target="_blank"><Icon name="telegram" />Telegram</Button>
                    </div>
                    <Divider style={{ marginTop: 50, marginBottom: 35 }} />
                    <Header as="h1" style={{ color: COLORS.TEXT_WHITE }}>Your Order</Header>
                    <Header as="h3" style={{ color: COLORS.TEXT_WHITE }}>{orderDetails.gameName}</Header>
                    <div style={{ textAlign: 'left' }}>
                        <p style={{ color: COLORS.TEXT_WHITE }}><strong>Order Number:</strong> {orderDetails.orderID}</p>
                        <p style={{ color: COLORS.TEXT_WHITE }}><strong>Order Status:</strong> {this.getStatusStr(orderDetails.status)}</p>
                        <p style={{ color: COLORS.TEXT_WHITE }}><strong>User Name:</strong> {orderDetails.userName}</p>
                        <p style={{ color: COLORS.TEXT_WHITE }}><strong>User ID:</strong> {orderDetails.userid}</p>
                        <p style={{ color: COLORS.TEXT_WHITE }}><strong>Server ID:</strong> {orderDetails.serverid}</p>
                        <p style={{ color: COLORS.TEXT_WHITE }}><strong>Item:</strong> {orderDetails.itemName?.replace('Diamonds', '💎')}</p>
                        <p style={{ color: COLORS.TEXT_WHITE }}><strong>Amount:</strong> ${orderDetails.amount}</p>
                    </div>
                    <Button style={{ marginTop: 30, marginBottom: 20, backgroundColor: COLORS.PRIMARY_GOLD, color: COLORS.BACKGROUND }} as={Link} to="/consumers">Back to Games</Button>
                </div>
            </Container></div>
    }

    renderStatus() {
        const { orderDetails } = this.state
        if (orderDetails.status === 'successful') {
            return <div>
                <h1>Thank you for your purchase.</h1>
                <h3 style={{ color: COLORS.TEXT_WHITE }}>Your order has been successfully delivered to your account.</h3>
            </div>
        } else if (orderDetails.status === 'pending-customer-payment') {
            return <div>
                <h1>Payment has not been completed.</h1>
                <h3 style={{ color: COLORS.TEXT_WHITE }}>Your payment method might have been rejected.</h3>
            </div>
        } else {
            return <div>
                <h1>Thank you for your purchase.</h1>
                <h3 style={{ color: COLORS.TEXT_WHITE }}>Your order is being processed. You may refresh this page to check your order status in a few moments' time.</h3>
            </div>
        }
    }

    renderTips() {
        const { orderDetails } = this.state
        if (orderDetails.status === 'successful') {
            return <div>
                <p style={{ color: COLORS.TEXT_WHITE }}>It may take a minute to reflect on your account. If you don't see the item, simply restart your game by completely closing it off and starting it up again.</p>
                <p style={{ color: COLORS.TEXT_WHITE }}>If it still doesn't appear after a while, please don't hesitate to contact us.</p>
            </div>
        } else if (orderDetails.status === 'pending-customer-payment') {
            return <div>
                <p style={{ color: COLORS.TEXT_WHITE }}>Please double check your payment details, and ensure that your Internet connection is secure. You may try to place the order again.</p>
                <p style={{ color: COLORS.TEXT_WHITE }}>If you are still facing problems with sending the payment, please don't hesitate to contact us.</p>
            </div>
        } else {
            return <div>
                <p style={{ color: COLORS.TEXT_WHITE }}>Orders may take up to a few minutes to be processed and delivered to your account. During game events, please expect a slight delay due to high demand.</p>
                <p style={{ color: COLORS.TEXT_WHITE }}>If your order status is doesn't show 'Success' after a while, please don't hesitate to contact us.</p>
            </div>
        }
    }

    getStatusStr(status) {
        if (status === 'successful') return 'Success ✅' 
        else if (status === 'pending-customer-payment') return 'Pending Customer Payment'
        else if (status === 'payment-received-pending-disbursement') return 'Payment Received. Pending Processing'
        else return status
    }

    fetchOrderDetails = async (orderId) => {
        try {
            const response = await axios.get(`/api/order/${orderId}/status`)
            var updatedOrder = { ...this.state.orderDetails }
            updatedOrder.status = response.data.status
            this.setState({ orderDetails: updatedOrder, error: null })
            if (response.data.status === 'successful') {
                clearInterval(this.intervalId)
                clearTimeout(this.timeoutId)
                this.setState({ loading: false })
            } else {
                this.setState({ loading: true })
            }
        } catch (err) {
            console.error("Error fetching order details:", err);
            this.setState({ loading: false, error: "Failed to fetch order details" })
            clearInterval(this.intervalId)
            clearTimeout(this.timeoutId)
        }
    }
}

export default PaymentSuccess